import { withStyles } from '@mui/styles'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import MaterialTable from '@material-table/core'
import React from 'react'
import { AddIcon, EditIcon, DeleteIcon } from '../../icons/index.js'
import PropTypes from 'prop-types'
import Snackbar from '../Snackbar/Snackbar'
import { notificar, notificacionObj } from '../Notification/NotificationFuncion'
import { exportMenuXlsx } from '../../util/exportXlsx'
import {localizationTable} from "../../util/utils";

class Table extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedCount: 0,
      notificacion: notificacionObj()
    }
  }

  notificarVacio = (mensaje) => {
    this.setState({ notificacion: notificar(mensaje, false) })
  }

  closeNotification = () => {
    this.setState({ notificacion: notificacionObj() })
  }

  render() {
    const {
      selectIdRow,
      id,
      onRowAdd,
      onRowUpdate,
      onRowDelete,
      permisosEditable
    } = this.props

    return (
      <div>
        <Snackbar
          color={this.state.notificacion.color}
          message={this.state.notificacion.errorGeneral}
          open={this.state.notificacion.open}
          closeNotification={this.closeNotification}
        />
        <ThemeProvider theme={theme} key={id}>
          <MaterialTable
            id={id}
            key={id}
            icons={{
              Add: () => <AddIcon style={{ color: 'blue' }} />,
              Edit: () => <EditIcon style={{ color: '#9c27b0', height:'2px' }} />,
              Delete: () => <DeleteIcon style={{ color: '#4caf50' }} />
            }}
            isLoading={this.props.isLoading}
            columns={this.props.columns}
            data={this.props.data}
            title={this.props.title}
            localization={localizationTable()}
            onRowClick={this.props.onRowClick}
            onSelectionChange={this.props.onSelectionChange}
            //editable={this.props.editable}
            editable={{
              onRowAdd: permisosEditable === true ? onRowAdd : null,
              onRowUpdate: permisosEditable === true ? onRowUpdate : null,
              onRowDelete: onRowDelete
            }}
            cellEditable={this.props.cellEditable}
            //actions={this.props.actions}
            options={{
              actionsColumnIndex: -1,
              paging:
                this.props.paging != null
                  ? this.props.paging
                  : this.props.data
                  ? this.props.data.length >= 10
                  : false,
              padding: 'dense',
              pageSize: this.props.pageSize ? this.props.pageSize : 10,
              exportMenu:
                this.props.exportButton !== false
                  ? exportMenuXlsx(this.props.exportFileName || this.props.title, this.notificarVacio)
                  : [],
              exportAllData:
                this.props.exportAllData != null
                  ? this.props.exportAllData
                  : true,
              search: this.props.search != null ? this.props.search : true,
              selection:
                this.props.selection != null ? this.props.selection : false,
              headerStyle: {
                backgroundColor: '#4CAF50',
                color: '#FFF',
                '&:hover,&:focus': {
                  color: '#FFF'
                },
                textAlign: 'center',
                fontSize: '12px',
                position: 'sticky',
                top: '0'
              },

                rowStyle: rowData => {
                    // Colores para ANULADOS
                    if (rowData.estado === 9 || rowData.estado === 'ANULADO') {
                        return {
                            backgroundColor: '#ff000033', // rojo suave
                            color: '#b30000', // texto rojo oscuro
                            fontWeight: 'bold',
                            fontSize: '11px'
                        }
                    }

                    // Color para fila seleccionada
                    if (selectIdRow === rowData.tableData.id || selectIdRow === rowData.uniqueId) {
                        return {
                            backgroundColor: '#37b15933',
                            fontSize: '11px'
                        }
                    }

                    // Fila normal
                    return { fontSize: '11px' }
                },
              fixedColumns: this.props.fixedColumns,
              tableLayout: this.props.tableLayout
                ? this.props.tableLayout
                : 'auto',
              filtering: this.props.filtering ? this.props.filtering : false,
              draggable: this.props.draggable ? this.props.draggable : false,
              grouping: this.props.grouping ? this.props.grouping : false,
              exportDelimiter: ';',
              exportFileName: this.props.exportFileName
                ? this.props.exportFileName
                : 'Reporte',

            }}
            detailPanel={this.props.detailPanel}
          />
        </ThemeProvider>
      </div>
    )
  }
}

const theme = createTheme({
  palette: {
    secondary: {
      main: '#3265b3 !important'
    }
  },
  components: {
    MuiSelect: {
      styleOverrides: {
        select: {
          padding: '5px 14px'
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: '1.3rem'
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          paddingTop: '5px!important',
          paddingBottom: '5px!important'
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          padding: '4px 5px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        }
      }
    },
    MuiTablePagination: {
      styleOverrides: {
        selectLabel: {
          fontSize: '0.8125rem'
        },
        displayedRows: {
          fontSize: '0.8125rem'
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: 'none !important'
        }
      }
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: '2px'
        }
      }
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          minHeight: '0px !important'
        }
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          marginBottom: '0px !important'
        }
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          height: 'inherit !important',

          backgroundColor: '#ffffff6b',
          '&:hover,&:focus': {
            backgroundColor: '#00618530 !important'
          },
          '&$selected': {
            backgroundColor: '#00618530'
          }
        }
      }
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          disabled: {
            display: 'none',
            '&:first-child': {
              display: 'inherit',
              paddingBottom: 0
            }
          }
        }
      }
    },

    MuiRadio: {
      styleOverrides: {
        root: {
          padding: '1px !Important',
          backgroundColor: '#red !important'
        }
      }
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontSize: 'small'
        }
      }
    }
  }
})

Table.propTypes = {
  isLoading: PropTypes.bool,
  columns: PropTypes.array,
  data: PropTypes.array,
  title: PropTypes.string,
  onRowAdd: PropTypes.func,
  onRowUpdate: PropTypes.func,
  onRowDelete: PropTypes.func,
  onRowClick: PropTypes.func,
  onSelectionChange: PropTypes.func,
  cellEditable: PropTypes.bool,
  paging: PropTypes.bool,
  pageSize: PropTypes.number,
  exportButton: PropTypes.func,
  exportAllData: PropTypes.func,
  search: PropTypes.bool,
  selection: PropTypes.bool,
  fixedColumns: PropTypes.object,
  tableLayout: PropTypes.object,
  filtering: PropTypes.bool,
  grouping: PropTypes.bool,
  exportFileName: PropTypes.func,
  detailPanel: PropTypes.string,
  id: PropTypes.string,
  selectIdRow: PropTypes.number
}

const styles = {
  highlight: {
    backgroundColor: '#eeeeee !important',
    '& *': {
      color: '#132f41'
    }
  }
}

const TablaDatos = withStyles(styles, { withTheme: true })(Table)
export default TablaDatos
